export default "__VITE_ASSET__DBA2eYrH__"